import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';

const WhyChiropractic = () => {
  const benefits = [
    "Natural Pain Relief without medication",
    "Improved Joint Mobility and flexibility",
    "Enhanced Nervous System Function",
    "Better Posture and spinal alignment",
    "Stress Reduction and relaxation",
    "Long-term Wellness and prevention"
  ];

  return (
    <section
      id="why-chiropractic"
      className="py-24 bg-forest text-cream relative overflow-hidden"
      style={{
        backgroundColor: "#4f5a33"
      }}>
      {/* Background Texture */}
      <div className="container-custom relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <span className="text-cream/70 font-medium tracking-widest uppercase text-sm mb-4 block">Holistic Health</span>
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-cream mb-8">Why Choose Chiropractic Care?</h2>
            <p className="text-cream/90 text-lg font-light mb-8 leading-relaxed">
              Chiropractic care is more than just fixing back pain. It's about optimizing your body's function by ensuring your nervous system is communicating effectively. By correcting misalignments, we help your body heal itself naturally.
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-start gap-3">
                  <CheckCircle className="w-5 h-5 text-cream/80 mt-1 flex-shrink-0" />
                  <span className="text-cream/90 font-light">{benefit}</span>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative h-[500px] rounded-sm overflow-hidden shadow-2xl"
          >
            <img 
              src="https://images.unsplash.com/photo-1768507423533-b87b62769758?q=80&w=800&auto=format&fit=crop" 
              alt="Chiropractic Adjustment" 
              className="w-full h-full object-cover"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WhyChiropractic;
